export default "__VITE_ASSET__23c69fe5__"